<template>
    <address>
        <div :class="contentCssClass">{{ property.address + (singleLine ? ',' : '') }}</div>
        <div :class="contentCssClass">{{ cityStateZip }}</div>
        <div :class="contentCssClass" v-if="country">{{ country }}</div>
    </address>
</template>

<script type="text/javascript">
    import ApiObject from '@/classes/ApiObject.js';
    import CountriesConfig from '@/config/countries.json';

    export default {

        props: {
            property: {
                type: ApiObject,
                required: true,
            },

            singleLine: {
                type: Boolean,
                default: false,
            },
            
        },

        computed: {
            contentCssClass() {
                if (this.singleLine) {
                    return 'd-inline-block me-1';
                }
                return null;
            },
            cityStateZip() {
                return this.property.city+', '+this.property.state+' '+this.property.zip;
            },

            country() {
                if ((this.property.country) && (this.property.country != 'US')) {
                    return CountriesConfig[this.property.country] || this.property.country;
                }

                return null;
            }
        },
    };

</script>
